/* eslint-disable no-bitwise */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-inline-comments */
export const GLOBAL = {
  isProduction: process.env.NODE_ENV !== 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
};

// ------------------------------
// USER Constants
// ------------------------------

export const RoleType = Object.freeze({
  EMPLOYEE: 'Employee',
  MANAGER: 'Manager',
  SITEADMIN: 'SiteAdmin',
  PARTNER: 'Partner',
  SUPERADMIN: 'SuperAdmin',
});

export const RoleCheck = Object.freeze({
  hasEmployee: 1, // 00001
  hasManager: 1 << 1, // 00010
  hasSiteAdmin: 1 << 2, // 00100
  hasPartner: 1 << 3, // 01000
  hasSuperAdmin: 1 << 4, // 10000
});

export const Feature = Object.freeze({
  autoOnboardNewHire: 13,
  autoApplyEssChanges: 12,
  standardScheduling: 11,
  mobileApplication: 10,
  benefitsManagement: 9,
  centeralizedData: 8,
  advancedTime: 7,
  advancedHR: 5,
  platformPricing: 1,
});

export const PermissionType = Object.freeze({
  viewSchedule: 'ViewSchedule',
  viewEmployee: 'ViewEmployee',
  modifySchedule: 'ModifySchedule',
  viewEmployeeRestricted: 'ViewEmployeeRestricted',
  modifyPassword: 'ModifyPassword',
  viewEmployeeContact: 'ViewEmployeeContact',
  modifyEmployeeContact: 'ModifyEmployeeContact',
  modifyEmployee: 'ModifyEmployee',
  modifyEmployeeRestricted: 'ModifyEmployeeRestricted',
  createEmployee: 'CreateEmployee',
  viewWages: 'ViewWages',
  modifyWages: 'ModifyWages',
  modifyPunches: 'ModifyPunches',
  modifyUnmatchedPunches: 'ModifyUnmatchedPunches',
  hubAdmin: 'HubAdmin',
  onboardingAdmin: 'OnboardingAdmin',
  benefitsAdmin: 'BenefitsAdmin',
  viewRoles: 'ViewRoles',
  modifyRoles: 'ModifyRoles',
  viewSettings: 'ViewSettings',
});

export const PermissionLevel = Object.freeze({
  none: 'None',
  self: 'Self',
  all: 'All',
  directReports: 'DirectReports',
  selfAndDirectReports: 'SelfAndDirectReports',
});

export const PermissionKeys = Object.keys(PermissionLevel);

export const NoPermissions = PermissionKeys.reduce((obj, key) => {
  return { ...obj, [key]: false };
}, {});

export const SessionKeys = Object.freeze({
  TOKEN: 'TOKEN',
  IMPERSONATING: 'IMPERSONATING',
});

export const IMPERSONATING_KEY = 'impersonating';

export const DRAWER_KEYS = Object.freeze({
  NAVIGATION_DRAWER: 'NAVIGATION_DRAWER',
});
